// External imports
import { Routes, Route, useLocation } from 'react-router-dom';

// Local imports
import SellPage from '../pages/Sell/Sell';
import BuybackPage from '../pages/buyback/Buyback';
import ChartsPage from '../pages/charts/Charts';
import TransactionsPage from '../pages/transactions/Transactions';
import SignIn from '../pages/SignIn/signIn';
import { ThemeProvider } from '@mui/material';
import { CacheProvider } from '@emotion/react';
import { cacheRtl, theme } from './theme';
import { ToastProvider } from '../components/toast-context';
import { DialogProvider } from '../components/dialog-context';
import ResponsiveDialog from '../components/dialog';
import Layout from '../components/layout';

// Component definition
function App() {
  const location = useLocation();
  const isSignInPage = location.pathname === '/';
  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <DialogProvider>
          <ToastProvider>
            {!isSignInPage ? (
              <Layout>
                <Routes>
                  <Route path="sell" element={<SellPage />} />
                  <Route path="buyback" element={<BuybackPage />} />
                  <Route path="chart" element={<ChartsPage />} />
                  <Route path="transactions" element={<TransactionsPage />} />
                </Routes>
                <ResponsiveDialog />
              </Layout>
            ) : (
              <Routes>
                <Route path="/" element={<SignIn />} />
              </Routes>
            )}
            <ResponsiveDialog />
          </ToastProvider>
        </DialogProvider>
      </ThemeProvider>
    </CacheProvider>
  );
}

// Default export
export default App;
